/**
  *
  * Usage:
  *
  *   data-sw-editable-content="cms | field"
  *   data-sw-editable-content-cms-key="<?= $viewData->key ?>"
  *
  *
  */

var $ = require('../sw-jquery');
var InlineTextView = require('../../lib/views/InlineTextView');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-editable-content]').each(function() {
    var $el = $(this);
    var params = $el.swDataParams('swEditableContent');
    params.el = $el;

    new InlineTextView(params);
  });

};
